import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Table, Button, FileInput } from "@mantine/core";

const { REACT_APP_ECLIPSE_API } = process.env;

const FileUploader = ({
  COM_Label,
  sto_DirPath,
  sto_FileName,
  COM_Width,
  COM_Height,
  COM_fontsize,
}) => {
  // State to manage the current image URL
  const curImgAPIURL = `${REACT_APP_ECLIPSE_API}${sto_DirPath}${sto_FileName}?id=${Math.random()}`;

  // State to manage selected file and upload status
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");

  const handleUpload = async () => {
    // console.log("handleUpload");
    if (!selectedFile) {
      setUploadStatus("📁Select File");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("sto_DirPath", sto_DirPath);
    formData.append("sto_FileName", sto_FileName);
    formData.append("COM_Width", COM_Width);
    formData.append("COM_Height", COM_Height);
    formData.append("COM_fontsize", COM_fontsize);

    try {
      const res = await axios.post(
        `${REACT_APP_ECLIPSE_API}/api/upload/upload_IMG_v2`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // setCurImgAPIURL(
      //   `${REACT_APP_ECLIPSE_API}${sto_DirPath}${sto_FileName}?id=${Math.random()}`
      // );
      setUploadStatus(`✅ Upload successful: ${res.data.filename}`);
      // console.log("(`✅ Upload successful: ${res.data.filename}`)");
    } catch (err) {
      setUploadStatus("❌ Upload failed.");
      console.error(err);
    }
  };

  useEffect(() => {
    handleUpload();
  }, [selectedFile]);

  return (
    <div className="FU_Container " style={{ width: COM_Width }}>
      <div className="FU_Flex_Col">
        <div>{COM_Label}</div>
        <img
          className="FU_Image"
          src={`${curImgAPIURL}?id=${Math.random()}`}
          onClick={() => {
            window.open(curImgAPIURL, "_blank");
          }}
        />
        <FileSizeChecker key={Math.random()} url={curImgAPIURL} />
        <div style={{ fontSize: "8px" }}>{sto_FileName}</div>

        {/* <input type="file" onChange={handleFileChange} /> */}

        <FileInput
          key={Math.random()}
          radius="xl"
          label=""
          placeholder={uploadStatus}
          value={selectedFile}
          onChange={(file) => {
            setSelectedFile(file);
            setUploadStatus("");
          }}
          accept="image/*"
        />

        {/* <button onClick={handleUpload} style={{ marginLeft: 10 }}>
          Upload
        </button> */}
        {/* <button
          onClick={() => {
            console.log("props", {
              lable,
              sto_DirPath,
              sto_FileName,
              COM_Width,
              COM_Height,
              COM_fontsize,
            });
          }}
        >
          check
        </button> */}
      </div>
    </div>
  );
};

// Component to check file size & Img Resoultion

const FileSizeChecker = ({ url }) => {
  const [sizeMB, setSizeMB] = useState(null);
  const [dimensions, setDimensions] = useState(null);
  const [error, setError] = useState(null);

  const getFileSize = async (url) => {
    try {
      const response = await fetch(url, { method: "HEAD" });
      const contentLength = response.headers.get("Content-Length");

      if (contentLength) {
        const sizeBytes = parseInt(contentLength, 10);
        const sizeInMB = (sizeBytes / (1024 * 1024)).toFixed(3);
        setSizeMB(sizeInMB);
      } else {
        setSizeMB(null);
        // setError("Content-Length not available");
      }
    } catch (err) {
      // setError("Failed to fetch file size");
    }
  };

  const getImageDimensions = (url) => {
    const img = new Image();
    img.onload = () => {
      setDimensions({ width: img.width, height: img.height });
    };
    img.onerror = () => {
      // setError("Failed to load image for resolution");
    };
    img.src = url;
  };

  useEffect(() => {
    if (url) {
      getFileSize(url);
      getImageDimensions(url);
    }
  }, [url]);

  return (
    <div>
      {error && <p style={{ color: "red" }}>Error: {error}</p>}
      {sizeMB !== null && <div>Size: {sizeMB} MB</div>}
      {dimensions && (
        <div>
          Resolution: {dimensions.width} × {dimensions.height}
        </div>
      )}
      {!error && sizeMB === null && !dimensions && <p>Loading...</p>}
    </div>
  );
};

export default FileUploader;
